/**
 * Menu lateral recolhido ou aberto, escolha de cada pessoa: no armazenamento
 * local do navegador; sem ele (modo privado, bloqueio), só na memória desta
 * aba. Começa aberto.
 */
import {useCallback, useEffect, useState} from 'react';

const memory = new Map<string, boolean>();

const storageKey = (userUid: string) => `ops-panel:menu-recolhido:${userUid}`;

export const readAsideCollapsed = (userUid: string): boolean => {
  const key = storageKey(userUid);
  try {
    return window.localStorage.getItem(key) === '1';
  } catch (error) {
    // Sem armazenamento: vale a memória
    return memory.get(key) ?? false;
  }
};

export const saveAsideCollapsed = (userUid: string, collapsed: boolean) => {
  const key = storageKey(userUid);
  memory.set(key, collapsed);
  try {
    window.localStorage.setItem(key, collapsed ? '1' : '0');
  } catch (error) {
    // Sem armazenamento: fica a memória
  }
};

export const useAsideCollapsed = (userUid = ''): [boolean, () => void] => {
  const [collapsed, setCollapsed] = useState(() => readAsideCollapsed(userUid));
  useEffect(() => setCollapsed(readAsideCollapsed(userUid)), [userUid]);

  const toggle = useCallback(() => {
    const next = !collapsed;
    saveAsideCollapsed(userUid, next);
    setCollapsed(next);
  }, [collapsed, userUid]);

  return [collapsed, toggle];
};
